module.exports = __webpack_public_path__ + "img/missionEnd-3-b.afc6d036.png";